var render, staticRenderFns
import script from "./BsNumberField.vue?vue&type=script&lang=js&"
export * from "./BsNumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a1b0b0",
  null
  
)

export default component.exports